export enum WeightUnitOfMeasureCode {
  Ounce = 'oz',
  Pound = 'lb',
  Gram = 'gr',
  Kilogram = 'kg',
}
